export default "__VITE_ASSET__D_1U$mMl__"